<template>
    <block>
      <h3 slot="title">车辆里程统计</h3>
       <div slot="content">车辆里程统计</div>
    </block>
</template>
<script>
import block from "./block";
export default {
    components:{block},
  data() {
    return {

    };
  },
  methods: {
  
  },
  mounted() {

  },
};
</script>


// WEBPACK FOOTER //
// src/components/wuliu/diaodukanban/block1.vue